import React from 'react'
import {
  Route,
  Redirect
} from "react-router-dom";

import AdminLayout from '@/layouts/admin'

import navData from './navData'
import PrivateRoute from './PrivateRoute'

class Routers extends React.Component {
  render () {
    return (
      <AdminLayout>
        <Route exact path="/admin">
          <Redirect to="/admin/home"/>
        </Route>
        {
          navData.map(r => (
            <PrivateRoute exact key={r.path} {...r}/>
          ))
        }
      </AdminLayout>
    )
  }
}

export default Routers